import React from "react";
import "../Styles/Feefrequency.css";

export default function Yearly() {
  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Yearly</h4>
      </div>

      <div className="ff-page-body">
        <div className="card ff-detail-card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table ff-detail-table mb-0">
                <tbody>
                  <tr>
                    <td className="fw-bold ff-detail-label">Fee Frequency ID</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Fee Frequency Name</td>
                    <td>Yearly</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Fee Frequency Status</td>
                    <td>Active</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
